import React, { useState, useEffect } from 'react';
import { Card, Button, message } from 'antd';
import { EyeOutlined, EyeInvisibleOutlined } from '@ant-design/icons';
import GeneralForm from '../general-form';
import { getConsigneeSchema, getBuyerSchema, getPaySchema, getPurchaserSchema, getSaleSchema } from './schema';
import { tradingOrderSensitiveDataApi } from '@service';
import './index.less';

let encryptData = null;
let obscureData = null;
let clickFlag = false;

const MessageGather = props => {
  const { data = {}, hasItem = {} } = props;
  const { consignee, buyer, pay, purchaser, sale, has_encrypt, order_id } = data;
  const { hasConsignee = false, hasBuyer = false, hasPay = false, hasPurchaser = false, hasSale = false } = hasItem;
  const [isShow, setIsShow] = useState(false);
  const [consigneeData, setConsigneeData] = useState({});
  const [consigneeSchema, setConsigneeSchema] = useState(getConsigneeSchema(consignee));

  useEffect(() => {
    setConsigneeData(consignee);
    setConsigneeSchema(getConsigneeSchema(consignee));
  }, [consignee]);

  const eyeClick = async () => {
    if (clickFlag) {
      return;
    }

    clickFlag = true;

    if (!isShow) {
      if (!obscureData) {
        // 从api里拿
        const { flag, data } = await tradingOrderSensitiveDataApi({ order_id });

        if (flag === 200) {
          obscureData = {
            full_name: data.full_name,
            user_address: data.address,
            user_phone: data.phone,
          };
        } else {
          message.error('获取解密信息失败！');
          return;
        }
      }
      setConsigneeSchema(getConsigneeSchema(obscureData));
    } else {
      if (!encryptData) {
        encryptData = consignee;
      }
      setConsigneeSchema(getConsigneeSchema(encryptData));
    }

    setIsShow(v => !v);

    clickFlag = false;
  };

  return (
    <div className="message-gather">
      {hasConsignee && (
        <Card
          title="收货人信息"
          extra={
            has_encrypt === '1' && (
              <Button type="link" onClick={eyeClick}>
                {isShow ? <EyeInvisibleOutlined /> : <EyeOutlined />}
              </Button>
            )
          }
        >
          {consigneeData && <GeneralForm schema={consigneeSchema}></GeneralForm>}
        </Card>
      )}

      {hasBuyer && <Card title="买家信息">{buyer && <GeneralForm schema={getBuyerSchema(buyer)}></GeneralForm>}</Card>}
      {hasPay && (
        <Card title="付款信息">{pay && <GeneralForm schema={getPaySchema(pay)} width="50%"></GeneralForm>}</Card>
      )}

      {hasPurchaser && (
        <Card title="买手信息">{purchaser && <GeneralForm schema={getPurchaserSchema(purchaser)}></GeneralForm>}</Card>
      )}

      {hasSale && <Card title="销售信息">{sale && <GeneralForm schema={getSaleSchema(sale)}></GeneralForm>}</Card>}
    </div>
  );
};

export default MessageGather;
